import { useState, useEffect } from 'react';

import useAppSettings from 'src/hooks/useAppSettings';

import { ModuleTypes } from 'src/@types/module/enums/moduleTypes';
import { WorkflowSubjectStateDto } from 'src/@types/workflow/types';
import { getWorkflowBinding } from 'src/services/workflow/workflowBindingService';

export default function useFolderWorkflowDefault(
  folderId: number | undefined,
  onDefault: (definitionNumber: number) => void
): WorkflowSubjectStateDto | null {
  const [state, setState] = useState<WorkflowSubjectStateDto | null>(null);
  const { modules } = useAppSettings();
  const isWorkflowModuleEnabled = modules.includes(ModuleTypes.WorkflowsModule);

  useEffect(() => {
    if (!folderId || !isWorkflowModuleEnabled) {
      setState(null);

      return undefined;
    }

    let isCurrent = true;

    getWorkflowBinding('folder', folderId)
      .then((current) => {
        if (!isCurrent || !current?.isBound || !current.workflowDefinitionNumber) {
          return;
        }

        setState(current);
        onDefault(current.workflowDefinitionNumber);
      })
      .catch(() => undefined);

    return () => {
      isCurrent = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folderId, isWorkflowModuleEnabled]);

  return state;
}
